import {Component, Input} from "@angular/core";
import {Comment} from "../../../model/comment";
import {CommentService} from "../../../services/data/comment.service";
import {PictureDetailService} from "./picture-detail.service";
import {Picture} from "../../../model/picture";
import {CurrentEventService} from "../../../services/communication/currentEventService";
import {Page} from "../../../model/page";
import {UrlService} from "../../../services/url.service";
import {BusinessRight} from "../../../model/business-right";
import {PhotoSwipeService} from "../../photoswipe/photo-swipe.service";

@Component({
  selector: 'picture-detail',
  template: require('./picture-detail.component.html'),
  styles: [
    require('./picture-detail.component.scss')
  ]
})

export class PictureDetailComponent {

  private PAGE_SIZE:number = 50;

  @Input() userRight:BusinessRight = null;

  opened:boolean = false;

  currentPicture:Picture = null;

  comments:Array<Comment> = [];
  currentPage:Page<Comment>;
  pageNumber:number = 1;
  hasNext:boolean = true;
  isLoading:boolean = false;

  commentToDelete:Comment;

  constructor(private commentService:CommentService,
              private pictureDetailService:PictureDetailService,
              private currentEventService:CurrentEventService,
              private urlService:UrlService, private photoSwipeService:PhotoSwipeService) {
    pictureDetailService.pictureChange$.subscribe(picture => this.changePicture(picture));

    photoSwipeService.pictureChange$.subscribe(state => {
      if(state=='afterChange' && photoSwipeService.hasComment) {
        this.changePicture(photoSwipeService.getCurrentPicture());
      }
    });
  }

  changePicture(picture:Picture) {
    this.comments = [];
    this.currentPage = null;

    if (picture != null) {
      this.pageNumber = 1;
      this.currentPicture = picture;
      this.opened = true;

      this.commentService.getPictureComments(this.currentEventService.currentEvent.id, picture.id, this.pageNumber, this.PAGE_SIZE).subscribe(
        commentPage => this.commentsLoaded(commentPage)
      );
    } else {
      this.opened = false;
      this.currentPicture = null;
    }

  }

  commentsLoaded(commentPage:Page<Comment>) {
    this.currentPage = commentPage;

    for (let comment of commentPage.content) {
      comment.owner.avatarUrl = this.urlService.getMemberAvatarUrl(comment.owner.id);
      this.comments.push(comment);
    }

    this.hasNext = !commentPage.last;
    this.isLoading = false;
  }

  loadComments() {
    if (!this.isLoading && this.hasNext) {
      this.isLoading = true;
      this.pageNumber++;

      this.commentService.getPictureComments(this.currentEventService.currentEvent.id, this.currentPicture.id, this.pageNumber, this.PAGE_SIZE).subscribe(
        commentPage => this.commentsLoaded(commentPage)
      );
    }
  }

  setCommentToDelete(comment) {
    this.commentToDelete = comment;
  }

  deleteComment() {
    this.commentService.deleteComment(this.currentEventService.currentEvent.id, this.commentToDelete.id).subscribe(
      response => {
        let index = this.comments.map(function (comment) {
          return comment.id;
        }).indexOf(this.commentToDelete.id);

        this.comments.splice(index, 1);
      }
    );
  }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/components/event/picture-detail/picture-detail.component.ts